export class OAuthUserInfos {
  amr: unknown;
  at_hash: string;
  aud: string;
  auth_time: number;
  email: string;
  email_verified: boolean;
  exp: number;
  ext_id: string;
  family_name: string;
  given_name: string;
  iat: number;
  idp: string;
  iss: string;
  name: string;
  nbf: number;
  nonce: string;
  preferred_username: string;
  s_hash: string;
  sid: string;
  sub: string;
  tenant: string;
  constructor(data?) {
    Object.assign(this, data);
  }
}
